<template lang="pug">
	.easy-creative--chat-bot
		VueBotUI.easy-creative--chat-bot(ref="bot", :messages="botData", :options="options", @msg-send="botMessageSendHandler", @init="init", :bot-typing="!!bot.typing", :inputDisable="inputDisabled")
			template(v-slot:actions="{ data }")
				button.qkb-action-item.qkb-action-item--send.active-button(@click="showUploadPopup")
					fas(icon="paperclip").qkb-action-icon.qkb-action-icon--send(:style="{ 'color': attachment && info.brandingVars['highlight-color'] }")
			.attachment-panel.flex-row.space.justify(v-if="attachment", :class="{ active: !!attachment }", slot="actions-top", :style="{ 'color': attachment && info.brandingVars['highlight-color'] }")
				.flex-row.space
					.flex-row.space-small.align-center
						fas(icon="paperclip", size="2xs")
						.font-small {{attachment.name}}
				.flex-row.space
					.remove-button.flex-row.align-center.center.hoverable.clickable(@click="$confirm(void 0, $tCaption('Do you want to remove attachment?')).then(() => attachment = null)")
						fas(icon="times")
			template(v-slot:message="data")
				.flex-row
					.attachment-file.flex-row.space-small.align-center.center.font-mini(v-if="data && data.attachment")
						fas(icon="paperclip")
						span {{data.attachment.name}}
			template(v-slot:actions-top="{ data }")
				.drag-over-handler.flex-row.align-center.center
					.upper.flex-row.space.align-center
						fas(icon="upload")
						span {{$tCaption('Drop files here')}}
		FileUploader(ref="uploader", :uploadText="$tCaption('Confirm')", :dropZoneHeight="480", :closeOnOutsideClick="false", :popupConfig="popupConfig", :isUIHidden="true", :initFiles="attachment ? [attachment] : null",
			@upload="onCommitFile", :dropText="$tCaption('Or drop file here to upload (pdf, txt, docx, image)')", :accept="supportedExtensions", :holdFiles="!!attachment", @remove-files="attachment = null",
			@file-selected="f => attachment = f[0]", :uploadButtonActive="!!(attachment && attachmentText)")
			.flex-col.space(v-if="attachment")
				.font-small.upper.grey {{ $tCaption('What would you like to do with the uploaded file?') }}
				DxTextArea(:height="200", :value.sync="attachmentText", stylingMode="filled", :placeholder="$tCaption('Write something here..')", valueChangeEvent="input")
</template>

<script>
	import { VueBotUI } from 'vue-bot';
	import FileUploader from 'app-core/FileUploader.vue';
	import DxTextArea from 'devextreme-vue/text-area';

	export default {
		translationCategory: 'creative.EasyCreativeChatBot',
		name: 'easy-creative-chat-bot',
		props: ['info'],
		components: {
			VueBotUI, FileUploader, DxTextArea
		},
		data() {
			return {
				bot: {
					data: [],
					typing: false,
					processing: false,
					initiated: false,
					img: require('assets/chatbot.png')
				},
				pool: [],
				attachment: null,
				attachmentText: null,
				popupConfig: {
					width: 720,
					autosize: true
				}
			};
		},
		computed: {
			options() {
				return {
					colorScheme: this.info?.brandingVars['active-bg'],
					botAvatarImg: this.bot.img,
					botAvatarSize: 42, 
					botTitle: this.$tCaption('Adthos Copilot')
				}
			},
			inputDisabled() {
				return this.bot.data.slice(-1)[0]?.disableInput;
			},
			botData() {
				return this.bot.data.map((f,i) => {
					if (i === this.bot.data.length - 1) {
						return f
					} else {
						return { ...f, options: null };
					}
				})
			},
			supportedExtensions() {
				return ['.pdf', '.txt', '.docx', '.wav', '.mp3', '.ogg', '.riff', '.aif', '.png', '.jpeg', '.jpg', '.webp'];
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeChatBot = this;
			this.$eventsBus.$on('chat-bot-send-message', this.onEasyCreativeChatBotMessage);
			this.$eventsBus.$on('chat-bot-processing', this.onEasyCreativeChatBotProcessing);

			this.$refs.bot.$el.addEventListener('dragover', this.onDragOver);
			this.$refs.bot.$el.addEventListener('dragleave', this.onDragLeave);
			this.$refs.bot.$el.addEventListener('drop', this.onDrop);

			this.$botEl = this.$refs.bot.$el;
			document.body.appendChild(this.$botEl);
		},
		destroyed() {
			this.$eventsBus.$off('chat-bot-send-message', this.onEasyCreativeChatBotMessage);
			this.$eventsBus.$off('chat-bot-processing', this.onEasyCreativeChatBotProcessing);
			document.body.removeChild(this.$botEl);
			delete this.$botEl;

			this.$refs.bot.$el.removeEventListener('dragover', this.onDragOver);
			this.$refs.bot.$el.removeEventListener('dragleave', this.onDragLeave);
			this.$refs.bot.$el.removeEventListener('drop', this.onDrop);
		},
		methods: {
			onDragOver(e) {
				if (__DEBUG__)
					console.debug('onDragOver', { e });

				e.preventDefault();
				this.$botEl.classList.add('drag-over');
			},
			onDragLeave(e) {
				if (__DEBUG__)
					console.debug('onDragLeave', { e });

				this.$botEl.classList.remove('drag-over');
			},
			onDrop(e) {
				if (__DEBUG__)
					console.debug('onDrop', { e });

				e.preventDefault();
				this.$botEl.classList.remove('drag-over');

				this.attachment = e.dataTransfer.files[0];
				this.showUploadPopup();
			},
			showUploadPopup() {
				this.attachmentText = null;
				this.$refs.uploader.showPopup();
			},
			onEasyCreativeChatBotProcessing(v) {
				this.bot.typing = Math.max(0, this.bot.typing + (v ? 1 : -1));
			},
			onCommitFile(files) {
				if (__DEBUG__)
					console.debug('On commit file', { files });
				if (files && files[0]) {
					this.$eventsBus.$emit('chat-bot-user-attachment', this.attachment, this.attachmentText);
					this.bot.data.push({
						agent: 'user',
						type: 'text',
						text: this.attachmentText,
						attachment: files[0]
					});
				}
				this.$nextTick(() => this.attachment = null);
			},
			onEasyCreativeChatBotMessage(msg, time, opts) {
				this.sendBotMessage(msg, time, opts);
			},
			botMessageSendHandler(e) {
				if (__DEBUG__)
					console.debug('On message send', { e });
				this.bot.data.push({
					agent: 'user',
					type: 'text',
					text: e.text,
					attachment: this.attachment
				});
				this.$eventsBus.$emit('chat-bot-user-message', e, this.attachment);
				this.attachment = null;
			},
			init(preventQuestion) {
				this.bot.initiated = true;
				if (!this.bot.data?.length && !this.bot.processing) {
					this.bot.data = [{
						agent: 'bot',
						type: 'text',
						text: this.$tCaption('Welcome to Adthos Copilot!')
					}];

					if (!preventQuestion) {
						this.sendBotMessage(this.$tCaption('How can I help you?'), 800);
					}
				}
			},
			sendBotMessage(msg, time, opts) {
				this.pool.push({ msg, time, opts });
				this.processPool();
			},
			processPool() {
				if (!this.pool.length || this.bot.processing) return;
				var { msg, time, opts } = this.pool[0];
				this.pool.splice(0, 1);

				if (opts?.force) {
					if (!this.bot.initiated) {
						this.init(true);
					}
				}

				this.bot.processing++;
				setTimeout(() => {
					this.bot.typing++;
					setTimeout(() => {
						this.bot.data.push({
							agent: 'bot',
							type: 'text',
							text: msg,
							...(opts || {})
						});
						this.bot.typing--;
						this.bot.processing--;

						setTimeout(this.processPool, 500);
					}, time || Math.max(0.5, Math.random()) * 1000);
				}, time || 0);

				if (this.$refs.bot && this.bot.initiated) {
					this.$refs.bot.botOpen();
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--chat-bot {
		.attachment-panel {
			padding: 5px 10px;

			background: #f5f5f5;
			border-top: 1px solid #e9e9e9;

			margin-bottom: -28px;
			transition: 0.3s;

			&.active {
				margin-bottom: 0px;
			}
		}
		
		.drag-over-handler {
			position: absolute;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 100%;
			background: #eeeeeecc;
			border: 3px dashed var(--branding-highlight-color);
			z-index: 100;
			color: var(--branding-highlight-color);
			pointer-events: none;
			opacity: 0;
			transition: 0.1s;
			font-size: 10px;
		}

		&.drag-over {
			.drag-over-handler {
				opacity: 1;
				font-size: 18px;
			}
		}
	}

</style>
